import { Component, computed, effect, inject, input, signal } from '@angular/core';
import { NearEndVouchersWidgetStore } from './near-end-vouchers-widget.store';
import { UserWidgetSetting } from '@libs/types/src/services/types/service-settings-user-widgets.type';
import { clientChipField, dateField, serviceField } from '../../../../../shared/components/kit/table/table.fields';
import { VoucherGridItemObject } from '@it2go/types';
import { nearEndVouchersFrag } from './near-end-vouchers-widget.query';
import { TableColumnType } from '../../../../../shared/components/kit/table/table.types';
import { Router } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { TooltipModule } from '@openng/optimus-ui/tooltip';
import { TableComponent } from '../../../../../shared/components/kit/table/table.component';
import { PrimeTemplate } from '@openng/optimus-ui/api';
import { ShortDatePipe } from '../../../../../shared/pipes/short-date.pipe';

@Component({
    selector: 'app-near-end-vouchers-widget',
    templateUrl: './near-end-vouchers-widget.component.html',
    styleUrl: './near-end-vouchers-widget.component.scss',
    providers: [NearEndVouchersWidgetStore],
    imports: [
        TranslatePipe,
        TooltipModule,
        TableComponent,
        PrimeTemplate,
        ShortDatePipe,
    ],
})
export class NearEndVouchersWidgetComponent {
    public readonly store = inject(NearEndVouchersWidgetStore);
    public readonly router = inject(Router);

    items = input<{ serviceId: string, widget: UserWidgetSetting }[]>([]);

    protected columns = computed(() => {
        const showServiceInfo = [...new Set(this.items().map(x => x.serviceId))].length > 1;

        let cols = [
            clientChipField('client', 'folder.person', false),
            {
                name: 'voucher',
                dataKey: null,
                type: TableColumnType.Vouchers,
                voucherOptions: { showDetail: false, maxWidth: 'initial' },
            },
            dateField('issueDate', false, false),
            {
                name: 'voucherTo',
            },
            {
                name: 'insuranceAbbr',
            },
        ];

        if (showServiceInfo) {
            cols = [
                ...cols.slice(0, 1),
                serviceField('service', 'folder.serviceId'),
                ...cols.slice(1),
            ];
        }

        return cols;
    });

    protected data = signal<VoucherGridItemObject[]>([]);

    constructor() {
        effect(async () => {
            if (!this.items().length) {
                return;
            }

            const promises = this.items().map(async (item) => {
                const voucherToDate = new Date();
                voucherToDate.setDate(voucherToDate.getDate() + (item.widget.days));

                return await this.store.api.getVouchers({
                    filter: [
                        [{ column: 'serviceId', operator: 'EQ', value: [item.serviceId] }],
                        [{
                            column: 'voucherTo',
                            operator: 'GTE',
                            value: [(new Date()).toISOString()],
                        }],
                        [{
                            column: 'voucherTo',
                            operator: 'LTE',
                            value: [voucherToDate.toISOString()],
                        }],
                        [{ column: 'nextVoucherNotExists', operator: 'EQ', value: ['1'] }],
                    ],
                }, nearEndVouchersFrag);
            });

            const data = await Promise.all(promises);
            this.data.set(data.flatMap(obj => (obj?.items || []) as VoucherGridItemObject[]));
        });
    }
}
